import { render, staticRenderFns } from "./SellerCatalog.vue?vue&type=template&id=b54a587e&lang=pug&"
import script from "./SellerCatalog.vue?vue&type=script&lang=js&"
export * from "./SellerCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports